import { Component } from '@angular/core';
import {AceiteTermosService} from "./services/aceite-termos.service";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'parceriaUsSpa';
  constructor(protected aceiteTermosService: AceiteTermosService) {
    this.aceiteTermosService.getPublicIp().subscribe(res => {
      if (res) {
        localStorage.setItem('ip', res.ip);
      }
    }, error => {
      console.error('Falha public IP (1):', error);
      this.aceiteTermosService.getPublicIp2().subscribe(res2 => {
        if (res2) {
          localStorage.setItem('ip', res2.ip);
        }
      }, error2 => {
        console.error('Falha public IP (2):', error2);
        this.aceiteTermosService.getPublicIp3().subscribe(res3 => {
          if (res3) {
            localStorage.setItem('ip', res3.origin);
          }
        }, error3 => {
          console.error('Falha public IP (3):', error3);
          this.aceiteTermosService.getPublicIp4().subscribe(res4 => {
            localStorage.setItem('ip', res4.ip);
          }, error4 => {{
            console.error('Falha public IP (4):', error4);
          }})
        });
      });
    });
  }
}
